import React, { useEffect, useMemo, useState } from 'react';
import { WhatsNewModalView, WhatsNewModalViewProps } from './WhatsNewModal.view';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  GetUnreadSiteNewsDocument,
  useGetUnreadSiteNewsQuery,
  useUpdateLastReadSiteNewsMutation
} from '../../../models/graphql';
import { useApolloClient } from '@apollo/client';

export type WhatsNewModalControllerProps = {
  //
};

export const WhatsNewModalController = (props: WhatsNewModalControllerProps): JSX.Element | null => {
  const { cache } = useApolloClient();
  const [showModal, setShowModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { data, loading: queryLoading } = useGetUnreadSiteNewsQuery();
  const [updateLastReadSiteNewsFn, { loading: setterLoading }] = useUpdateLastReadSiteNewsMutation();

  const showAllHandler = () => {
    navigate({ pathname: '/whats-new' });
  };

  const newsIdArray: number[] | null = data?.unreadSiteNews.map(item => +(item.id || 0)) ?? null;
  const latestId = newsIdArray ? Math.max(...newsIdArray) : null;

  const onClose = () => {
    setShowModal(false);
    if (latestId) {
      // Set the cache unread site news to empty array as we shouldn't have any unread after updating the last read news.
      cache.writeQuery({
        query: GetUnreadSiteNewsDocument,
        data: {
          unreadSiteNews: []
        }
      });
      updateLastReadSiteNewsFn({ variables: { siteNewsId: `${latestId}` } });
    }
  };

  useEffect(() => {
    if (data && data.unreadSiteNews.length && location.pathname !== '/whats-new') {
      setShowModal(true);
    }
  }, [data, location.pathname]);

  const news = useMemo(() => (data ? data.unreadSiteNews : null), [data]);

  const args: WhatsNewModalViewProps = {
    ...props,
    news,
    onClose,
    showAllHandler,
    loading: queryLoading || setterLoading
  };

  return showModal ? <WhatsNewModalView {...args} /> : null;
};
